module.exports = __webpack_public_path__ + "static/media/a16baf33.jpg";